import 'date-fns';
import React from 'react';

// @mui/icons-material
// @mui/material components
import {GridItem} from '../../../../components/Grid';
import Button from '../../../../components/CustomButtons/Button';
import Grid from '@mui/material/Grid';
import FilterDropdown from '../panelSegments/FilterDropdown';
import {ArrayBasedMenuItem} from "../panelSegments/components";
import FilterDateTime from "../panelSegments/FilterDateTime";
import customSelectStyle from "../../../../assets/jss/customSelectStyle";
import {makeStyles} from "@mui/styles";
const useStyles = makeStyles((theme) => {
  return {
    button: {
      margin: theme.spacing(2),
      marginTop: 0
    },
    ...customSelectStyle
  }
})

const ESignSearchPanel = props => {
  const {
    role,
    initialStatus,
    statusSelect,
    onHandleStatusSelect,
    includeAllStatus = true,
    searchStatusByMethod  = ArrayBasedMenuItem,
    beginDate,
    onHandleBeginDateSelect,
    endDate,
    onHandleEndDateSelect,
    renderButton = true,
    buttonText = '',
    buttonIcon,
    onButtonClick,
    customButtons = []

  } = props;

  const classes = useStyles();

  const allButtonElements = [];
  if (renderButton) allButtonElements.push(
    <Button
      color="primary"
      className={classes.button}
      component="span"
      variant="contained"
      onClick={onButtonClick}
    >
      {buttonIcon ? React.createElement(buttonIcon) : undefined} {buttonText}
    </Button>);
  if (customButtons) customButtons.forEach(button => allButtonElements.push(button));

  const buttonGridItems = [];
  allButtonElements.forEach((button, index) => buttonGridItems.push(<GridItem
    key={index}
    xs={12}
    md={2}
  >
    {button}
  </GridItem>));

  return (
    <Grid container>
      <Grid
        item
        xs={12}
      >
        <Grid container>
          <FilterDropdown
            classes={classes}
            optionNameDisplay={"Status"}
            optionNameDisplayPlural={"Status"}
            optionNameInternal={"statusSelect"}
            optionId={"status-select"}
            includeAllOptionsAsOption={includeAllStatus}
            initialOptions={initialStatus}
            onHandleSelect={onHandleStatusSelect}
            optionSelect={statusSelect}
            menuItemListMethod={searchStatusByMethod}
          />
          <FilterDateTime
            classes={classes}
            optionNameDisplay={"Begin File Date"}
            optionNameInternal={"begin date"}
            optionId={"begin-date"}
            onHandleSelect={onHandleBeginDateSelect}
            defaultValue={beginDate}
          />
          <FilterDateTime
            classes={classes}
            optionNameDisplay={"End File Date"}
            optionNameInternal={"end date"}
            optionId={"end-date"}
            onHandleSelect={onHandleEndDateSelect}
            defaultValue={endDate}
          />
        </Grid>
      </Grid>
      <Grid container>
        {buttonGridItems}
      </Grid>
    </Grid>
  )
}

export default ESignSearchPanel;
